/* eslint-disable @typescript-eslint/no-throw-literal */
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { IFetchImagingTest, IFetchImagingTestViews, IImagingTest } from '~/interfaces'
import { HttpStatusCode } from '~/protocols/http'
import { getImagingTestFetchFunction, message } from '~/services'
import { hasObjectValue } from '~/utils'

const UNIQUE_KEY = 'imageTest'

export const useFetchImagingTest = (
  fetchParams: IFetchImagingTest | null,
  view: IFetchImagingTestViews | null,
  config?: UseQueryOptions<IImagingTest, Error, IImagingTest>
): UseQueryResult<IImagingTest, Error> => {
  const fetcher = async () => {
    if (!fetchParams) throw new Error('fetchParams is required')
    if (!view) throw new Error('view is required')

    try {
      const fetchImagingTest = getImagingTestFetchFunction(view)
      const response = await fetchImagingTest(fetchParams)
      const isResponseEmpty = !hasObjectValue({ ...response })

      if (isResponseEmpty) {
        throw message('detailsMedicalEvents.emptyResponseFetched')
      }

      return response
    } catch (error: any) {
      if (typeof error === 'string') throw new Error(error)
      else if (error?.status === HttpStatusCode.notFound) throw new Error(message('messages.genericNotFound'))
      else if (error?.status === HttpStatusCode.serverError) throw new Error(message('messages.genericUnexpectedError'))
      else throw new Error(message('messages.genericUnexpectedError'))
    }
  }

  return useQuery<IImagingTest, Error>([UNIQUE_KEY, fetchParams?.pathParams], fetcher, {
    cacheTime: Infinity,
    staleTime: Infinity,
    enabled: !!fetchParams || !!view,
    ...config
  })
}
